import { Routes } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';
import { LoginComponent } from './login/login.component';
import { CallbackComponent } from './callback/callback.component';
import { ShellComponent } from './shell/shell.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'callback', component: CallbackComponent },
  { 
    path: '', 
    component: ShellComponent,
    canActivate: [authGuardFn],
    children: [
      {
         path: '',
         title: 'Saisie de Correction',
         loadComponent: () => import('./saisie-correction/saisie-correction.component').then(m => m.SaisieCorrectionComponent)
      },
      { path: '**', redirectTo: '' }
    ]
  },
  { path: '**', redirectTo: '' }
];
